import {
    MONUMPAY_DEPOSIT,
    MONUMPAY_DEPOSIT_SUCCESS,
    MONUMPAY_DEPOSIT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
    loading: false,
    momunpay: null,
};

const monumpayReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case MONUMPAY_DEPOSIT:
            return { ...state, loading: true };
        case MONUMPAY_DEPOSIT_SUCCESS:
            return {
                ...state,
                momunpay: action?.payload,
                loading: false,
            };
        case MONUMPAY_DEPOSIT_FAILURE:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default monumpayReducer;
